// src/components/PrivateRoute.jsx
import { Navigate } from 'react-router-dom';
import { isAuthenticated, performLogout } from '../utils/auth';
import { useChatContext } from '../context/useChatContext.js';

function PrivateRoute({ children }) {
  const { isAuthReady } = useChatContext();
  const authenticated = isAuthenticated();

  if (!isAuthReady) {
    return (
      <div className="app-boot-loading">
        <div className="app-boot-loading__content">Carregando sessão...</div>
      </div>
    );
  }

  if (!authenticated) {
    performLogout();
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default PrivateRoute;
